/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Premium_Feature_TitleInputs */

const en_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Original Pro features`)
};

const ar_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع ميزات المحترفين الأصلية`)
};

const de_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Funktionen von Original Pro`)
};

const es_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las funciones originales de Pro`)
};

const fr_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les caractéristiques de Forest Pro`)
};

const it_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le funzionalità originali Pro`)
};

const ja_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロ版の全機能`)
};

const ko_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 Original Pro 기능`)
};

const pt_br_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as funcionalidades do Pro Original`)
};

const ru_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все исходные функции Pro`)
};

const th_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสมบัติโปรดั้งเดิมทั้งหมด`)
};

const tr_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Orijinal Pro özellikleri`)
};

const zh_cn_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原专业版所有功能`)
};

const zh_tw_subscription_service_level_compare_premium_feature_title = /** @type {(inputs: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原專業版所有功能`)
};

/**
* | output |
* | --- |
* | "All Original Pro features" |
*
* @param {Subscription_Service_Level_Compare_Premium_Feature_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_premium_feature_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Premium_Feature_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Premium_Feature_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_premium_feature_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_premium_feature_title(inputs)
	return zh_tw_subscription_service_level_compare_premium_feature_title(inputs)
});